import FieldPaymentsCount from './FieldPaymentsCount';
export default FieldPaymentsCount;
